import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

/**
 * Dropdown to select team members, based upon a number of filter rules. If no filter is provided, all team members
 * will be selected
 *
 * @param control       react-hook-form control parameter ( required )
 * @param name          react-hook-form name
 * @param rules
 * @param placeholder   Default placeholder
 * @param isSearchable  see react-select documentation
 * @param isClearable   see react-select documentation
 * @param isMulti       see react-select documentation
 * @param readOnly      Disabled control
 * @param team_id       Encrypted team ID. Must be urlencoded
 * @param filter        filter children | staff
 *
 * @returns {JSX.Element}
 *
 */
const DropdownTeamMembers = ( { control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, team_id, organisation_id, filter } ) =>
{
    const org = organisation_id === undefined ? 'current' : organisation_id ;

    const filterParam = filter === 'staff' || filter === 'children' ? '&filter=' + filter : '' ;

    const url = '/organisation/' + org + '/users?exclude_team_id=' + team_id + '&user_type=team' + filterParam ;

    const fields = { url: url, keyFieldName: 'user_id', labelFieldName: 'fullNameType', additionalFields: ['idusers', 'userTypeId'] }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownTeamMembers;
